(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('MarketPriceController', MarketPriceController);

    MarketPriceController.$inject = ['$state', '$scope', 'MarketPrice', 'ParseLinks', 'AlertService', 'ToastrService', 'SingleDblClickService', 'paginationConstants', 'pagingParams'];

    function MarketPriceController($state, $scope, MarketPrice, ParseLinks, AlertService, ToastrService, SingleDblClickService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.loadAll = loadAll;
        vm.page = 0;

        vm.gridOptions = {
            paginationPageSizes: [25, 50, 75, 100, 200],
            paginationPageSize: 100,
            enableFiltering: true,
            enableGridMenu: true,
            enablerowSelection: false,
            enableSelectAll: false,
            useExternalPagination: true,
            rowTemplate: SingleDblClickService.rowTemplate(),
            onRegaisterApi: function(gridApi) {
                gridApi.pagination.on.paginationChanged($scope, function(newPage, pageSize) {
                    vm.page = newPage - 1;
                    loadAll();
                });
                gridApi.core.on.sortChanged($scope, function(grid, sortColumns) {
                    if(sortColumns && sortColumns.length > 0 && sortColumns[0]) {
                        vm.predicate = sortColumns[0].field;
                        vm.reverse = sortColumns[0].sort.direction === 'asc';
                    } else {
                        vm.predicate = 'id';
                        vm.reverse = true;
                    }
                    loadAll();
                });
                $scope.gridApi = gridApi;
            },
            enableColumnResizing: true,
            columnDefs: [
                {name:'Year', field: 'year', visible: true},
                {name:'Month', field: 'month', visible: true},
                {name:'Price', field: 'price', visible: true},
                {name:'Price Type', field: 'priceType', visible: true},
                {name:'Unit Type', field: 'wtUnitType', visible: true},
                {name:'Price Display', field: 'priceDisplay', visible: true}
            ]
        };

        loadAll();

        function loadAll () {
            MarketPrice.query({
                page: vm.page,
                size: vm.gridOptions.paginationPageSize,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.marketPrices = data;
                vm.gridOptions.data = vm.marketPrices;
                vm.gridOptions.totalItems = headers('X-Total-Count');
                ToastrService.success("Successfully fetch Market Prices", "Success!");
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')
            });
        }

        $scope.rowSingleClick = function(row) {
            SingleDblClickService.singleClick(row, 'market-price-detail', 'market-price');
        };

        $scope.rowDblClick = function(row) {
            $state.go('market-price.edit',{"id": row.entity.id});
        }

        vm.createTab = function(data) {
            $scope.$emit('handleEmit',data);
        }
    }
})();
